import { fadeIn, fadeInUp } from '@/constants/motions';
import Image from '@/ui/Image';
import cx from 'classnames';
import { motion } from 'framer-motion';

export default function TextImageAsideBlock({
  sectionClassName,
  imageClassName,
  imageDirection,
  image,
  subtitle,
  title,
  children,
}) {
  const order = {
    left: 'order-1',
    right: 'lg:order-2',
  }[imageDirection];

  return (
    <motion.section
      className={cx('my-16 px-4', sectionClassName)}
      initial="hidden"
      transition={{
        ...fadeIn.transition,
        when: 'beforeChildren',
        staggerChildren: 0.4,
      }}
      variants={fadeIn}
      viewport={fadeIn.viewport}
      whileInView="visible"
    >
      <div className="container-screen">
        <div className="grid items-center gap-8 lg:grid-cols-2">
          <motion.div className={order} variants={fadeInUp}>
            <Image
              alt="Image"
              className={cx(
                'aspect-video max-w-screen-sm overflow-hidden rounded-xl object-cover shadow-lg',
                imageClassName
              )}
              src={image}
            />
          </motion.div>
          <motion.div className="order-1" variants={fadeInUp}>
            {subtitle && <h3 className="text-xl text-primary-500 lg:text-2xl">{subtitle}</h3>}
            {typeof title === 'string' ? (
              <h2 className="mt-4 text-3xl md:text-4xl xl:text-5xl">{title}</h2>
            ) : (
              title
            )}
            <div className="prose prose-neutral mt-6 max-w-none leading-normal">{children}</div>
          </motion.div>
        </div>
      </div>
    </motion.section>
  );
}
